<template>
  <div id="nav-wrapper">
    <div id="nav-menu">
      <a class="nav-link" href="/" @click="trackNavClick('Home')">Home</a>
      <a class="nav-link" href="/merch" @click="trackNavClick('Merch')">Merch</a>
      <a class="nav-link" href="/tour" @click="trackNavClick('Tour')">Tour</a>
      <a class="nav-link"
        href="https://www.youtube.com/playlist?list=PLkxl7w222NEZBr45FZOL7faYS2rg-ZZw0"
        target="_blank"
        @click="trackNavClick('Videos')">Videos</a>
      <a class="nav-link" href="/creators" target="_blank" @click="trackNavClick('Creators')">Creators</a>
      <a class="nav-link" v-smooth-scroll href="#contact" @click="trackNavClick('Contact')">Contact</a>
    </div>
  </div>
</template>
<script>
export default {

  name: "NavBar",
  methods: {
    trackNavClick(label) {
      if (window.gtag) {
        window.gtag("event", "click", {
          event_category: "Navigation",
          event_label: label,
          transport_type: "beacon",
        });
      }
    },
  },
};
</script>
<style scoped>
#nav-menu {
  list-style: none;
  float: none;
  position: relative;
}

.nav-link {
  position: relative;
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  margin: 0px 20px 10px 20px;
  text-align: left;
  color: white;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
}

.nav-link {
  text-transform: uppercase;
  font-size: 34px;
  text-align: right;
  font-weight: 700;
  text-shadow: 1px 2px #00000073;
  transition: all 0.1s ease;
  -webkit-transition: all 0.1s ease;
}

.nav-link:hover {
  text-decoration: none;
  border-bottom: 4px solid;
}

@media (max-width: 768px) {
  .nav-link {
    font-size: 19px;
  }
}
</style>
